import 'react-app-polyfill/ie11'
import 'core-js/features/object/entries'
import 'core-js/features/object/values'
import 'core-js/features/object/keys'
import 'core-js/features/array/find-index'
import 'core-js/features/array/find'
import 'core-js/features/string/starts-with'
import 'core-js/features/function/name'
import 'core-js/features/set'
import ResizeObserver from 'resize-observer-polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
import { ThemeProvider } from 'styled-components'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'

import 'index.css'
import QuizProvider from 'store/QuizStore'
import App from './App'
import { theme } from 'styled'

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://a54371b21c214762baa35e2034b5fb29@o570420.ingest.sentry.io/5717235',
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 0,
  })
}

if (!window.ResizeObserver) {
  window.ResizeObserver = ResizeObserver
}

ReactDOM.render(
  <React.StrictMode>
    <QuizProvider>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </QuizProvider>
  </React.StrictMode>,
  document.getElementById('root')
)
